module.exports = __webpack_public_path__ + "9f0e29cf962fa2c6dcbdd41f8ef6dfdd.MP3";